module.exports = __webpack_public_path__ + "static/img/content4.8c175d88.png";